import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Garage = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['garage', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let options = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(options)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('garage_information')}
    tableConfig={{
      key: "id",
      apiPath: "garage/list",
      allowDelete: {
        visible: true,
        key: "garage_id",
        apiPath: "garage/delete",
        paramType: 'param'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'garage_name',
          caption: t('garage_name'),
          allowFiltering: true
        },
        {
          dataField: 'contact_name',
          caption: t('contact'),
          allowFiltering: true
        },
        {
          dataField: 'tel',
          caption: t('phone_number'),
        },
        {
          dataField: 'address',
          caption: t('address'),
        },
        {
          dataField: 'loc',
          caption: t('coordinates'),
        },
        {
          dataField: 'status',
          caption: t('status'),
          allowFiltering: true,
          cellRender: (e) => e.value === "Y" ? 'ใช้งาน' : 'ไม่ใช้งาน'
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('garage_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('garage_name'), value: 'garage_name' },
          { label: t('contact'), value: 'contact_name' },
          { label: t('phone_number'), value: 'tel' },
          { label: t('address'), value: 'address' },
          { label: t('coordinates'), value: 'loc' },
          { label: t('status'), value: (col) => (col.status === "Y" ? 'ใช้งาน' : 'ไม่ใช้งาน') },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      garage_name: "",
      address: "",
      phone: "",
      tel: "",
      contact_name: "",
      loc: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: t('garage_information'),
      required: ["garage_name"],
      fieldTypeNumber: [],
      paramName: "garage_id",
      apiPath: {
        "get": '',
        "post": 'garage/add',
        "put": 'garage/update'
      },
      elements: [
        {
          fieldName: "garage_name",
          label: t('garage_name'),
          placeholder: t('garage_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "contact_name",
          label: t('contact'),
          placeholder: t('contact'),
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "address",
          label: t('address'),
          placeholder: t('address'),
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "tel",
          label: t('phone_number'),
          placeholder: t('phone_number'),
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "loc",
          label: t('coordinates'),
          placeholder: t('coordinates'),
          inputType: "text",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          isOneRow: true,
          options: optionStatus
        }
      ]
    }}
  />
}))

export default Garage